import { HTTP } from "@/api";

export default {
  getAdminList({ commit, state }) {
    commit("isLoading", {
      key: "admins",
      status: true
    });
    const search = state.admins.search;
    const limit = state.admins.limit;
    const offset = (state.admins.page - 1) * limit;
    const url = `/v2/admin/list?limit=${limit}&offset=${offset}&search=${search}`;
    return HTTP.get(url).then(res => {
      const data = res.data;
      if (data.success) {
        commit("admins", data.result.admins);
        commit("adminsCounter", data.result.total);
      }
      return data.success;
    });
  },
  createAdmin({ commit }, data) {
    return HTTP.post(`/v2/admin`, data).then(res => {
      const data = res.data;
      if (data.success) {
        commit("admin", data.admin);
      }
      return data.msg;
    });
  },
  updateAdmin({ commit }, data) {
    return HTTP.put(`/v2/admin`, data).then(res => {
      const data = res.data;
      if (data.success) {
        commit("admin", data.admin);
      }
      return data.success;
    });
  },
  removeAdmin({ commit, state }, id) {
    return HTTP.delete(`/v2/admin/${id}`).then(res => {
      const data = res.data;
      if (data.success) {
        const admins = state.admins.list.filter(({ _id }) => _id !== id);
        commit("admin", admins);
      }
      if (data.error) throw new Error(data.error);
      return data.success;
    });
  },
};
